import React, {Component} from 'react'
import '../../styles/Admin.css'
import {Tab, Tabs} from "react-bootstrap-tabs";
import NowyWpis from "./galeriaComponents/NowyPlik";
import EdytujWpis from "./galeriaComponents/EdytujWpis";
import AdminPanel from "../AdminPanel";
// import '../../styles/Tabs.css'

export default class AdminGaleria extends Component {

    constructor(props) {
        super(props);

        this.state = {
            selectedItem: '',
            title: '',
            selectedIndex: 0
        }
    }

    render() {
        return <div>{this.props.container ? <div className="componentContainer">
            <div className="row">
                <div className="col-6">
                    <h5 style={{paddingLeft: 10}}>Menedżer plików</h5>
                </div>
                {this.props.modal ? <div className="col-6 text-right">
                    <i className="fa fa-times" style={{color: 'red', cursor: 'pointer'}}
                       onClick={() => this.props.closeModal()}> </i>
                </div> : null}
            </div>
            <hr/>
            <Tabs selected={this.state.selectedIndex} onSelect={(index, label) => {
                this.setState({selectedIndex: index});
            }}>
                <Tab label={'Dodaj plik'}>
                    <NowyWpis goZarzadzanie={() => this.setState({selectedIndex: 0})}
                              crop={this.props.crop}
                              modal={this.props.modal}
                              setImage={(image, zdjecie) => this.props.setImage(image, zdjecie)}
                              closeModal={() => this.props.closeModal()}
                              goEdycja={() => this.setState({selectedIndex: 2})}
                              setItem={(item) => this.setState({selectedItem: item, title: item.tytul})}
                              wybierzObraz={(obraz) => this.props.wybierzObraz(obraz)}/>

                </Tab>
                <Tab label={this.state.title} disabled={this.state.selectedIndex !== 2}>
                    <EdytujWpis item={this.state.selectedItem} goZarzadzanie={() => this.setState({selectedIndex: 0})}/>
                </Tab>
            </Tabs>
        </div> : <AdminPanel>
            <div className="componentContainer">
                <div className="row">
                    <div className="col-6">
                        <h5 style={{paddingLeft: 10}}>Menedżer plików</h5>
                    </div>
                    {this.props.modal ? <div className="col-6 text-right">
                        <i className="fa fa-times" style={{color: 'red', cursor: 'pointer'}}
                           onClick={() => this.props.closeModal()}> </i>
                    </div> : null}
                </div>
                <hr/>
                <Tabs selected={this.state.selectedIndex} onSelect={(index, label) => {
                    this.setState({selectedIndex: index});
                }}>
                    <Tab label={'Dodaj plik'}>
                        <NowyWpis goZarzadzanie={() => this.setState({selectedIndex: 0})}
                                  crop={this.props.crop}
                                  modal={this.props.modal}
                                  setImage={(image, zdjecie) => this.props.setImage(image, zdjecie)}
                                  closeModal={() => this.props.closeModal()}
                                  goEdycja={() => this.setState({selectedIndex: 2})}
                                  setItem={(item) => this.setState({selectedItem: item, title: item.tytul})}
                                  wybierzObraz={(obraz) => this.props.wybierzObraz(obraz)}/>

                    </Tab>
                    <Tab label={this.state.title} disabled={this.state.selectedIndex !== 2}>
                        <EdytujWpis item={this.state.selectedItem}
                                    goZarzadzanie={() => this.setState({selectedIndex: 0})}/>
                    </Tab>
                </Tabs>
            </div>
        </AdminPanel>}</div>
    }

}



// WEBPACK FOOTER //
// ./src/components/admin/adminComponents/AdminGaleria.js